import { useSingleTaskQuery } from "@hooks/queries/tasks/useSingleTaskQuery";
import { useFetchDietitianAccountQuery } from "@hooks/queries/settings";

export const useIsTaskEditable = (currentTaskId: string | null) => {
  const { account } = useFetchDietitianAccountQuery();
  const { data } = useSingleTaskQuery(currentTaskId ?? "");

  return account?.id === data?.owner?.id;
};
